import type { FileKind } from './projectsApi';

// How a stored file can be shown in the preview modal (components/resources/
// FilePreviewModal), decided from its kind and extension.

export type PreviewType = 'pdf' | 'image' | 'video' | 'audio' | 'text' | 'none';

const VIDEO_EXT = ['mp4', 'webm', 'mov', 'm4v', 'ogv'];
const AUDIO_EXT = ['mp3', 'wav', 'm4a', 'ogg', 'oga', 'aac', 'flac', 'weba'];
const TEXT_EXT = [
  'txt',
  'md',
  'csv',
  'json',
  'log',
  'xml',
  'yml',
  'yaml',
  'html',
  'css',
  'js',
  'ts',
];

export function previewTypeOf(file: { name: string; kind: FileKind }): PreviewType {
  if (file.kind === 'pdf') return 'pdf';
  if (file.kind === 'image') return 'image';
  const ext = (file.name.split('.').pop() ?? '').toLowerCase();
  if (VIDEO_EXT.includes(ext)) return 'video';
  if (AUDIO_EXT.includes(ext)) return 'audio';
  if (TEXT_EXT.includes(ext)) return 'text';
  return 'none';
}
